import ContentConfig from '../../config/ContentConfig';
import logger from '../../log';
import { ElevenAgentData } from '../../ecdn11/interfaces';
import { PrimingData } from '../../priming/interfaces';
import { ReporterSections } from './constants';
import { dispatchUpdateReportEvent } from '../../events/dispatch';
import { Ecdn11Agent } from '../../reporter/report/Report';

const log = logger.getLogger(__filename);
export const DISABLED_MSG_10 = 'ecdn10 agent disabled, no agent data fetched';
export const DISABLED_MSG_11 = 'ecdn11 agent disabled, no agent data fetched';

export interface ReportArgs {
  data: PrimingData;
}

export const reportECDN10AgentBlock = (args: ReportArgs): void => {
  const obj = args.data;
  const data = (obj && obj.ecdn10 && obj.ecdn10.agentData) || undefined;
  if (ContentConfig.getInstance().legacy.disabled) {
    log.debug(DISABLED_MSG_10);
    return;
  }
  if (!data || !data.version) {
    log.debug('No ecdn10 agent data found.');
    return;
  }
  const agent = {
    v: data['version'],
    nodeId: data['node_id'],
    machineName: data['machine_name'],
    machineUserGuid: data['machine_user_guid']
  } as Ecdn11Agent;
  log.debug('reportECDN10AgentBlock:', { agent });
  const section = ReporterSections.ECDN10;
  dispatchUpdateReportEvent({ value: { agent }, section });
};

export const reportECDN11AgentBlock = (args: ReportArgs): void => {
  if (ContentConfig.getInstance().agent.disabled) {
    log.debug(DISABLED_MSG_11);
    return;
  }
  if (!args.data || !args.data.ecdn11 || !args.data.ecdn11.version) {
    log.debug('No ecdn11 agent data found', args.data && args.data.ecdn11);
    return;
  }
  const data: ElevenAgentData = args.data.ecdn11;
  const agent = {
    v: data.version,
    agentId: data.agentId || data.agentID,
    machineName: data.host,
    machineUser: data.user
  };
  log.debug('reportECDN11AgentBlock:', { agent });
  const section = ReporterSections.ECDN11;
  dispatchUpdateReportEvent({ value: { agent }, section });
};

const reportAgentInformation = (args: ReportArgs): void => {
  reportECDN10AgentBlock(args);
  reportECDN11AgentBlock(args);
};

export default reportAgentInformation;
